module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    class: {
      'spinner-disabled': _vm.disabled
    }
  }, [_c('input', {
    ref: "input",
    staticClass: "form-control",
    class: {
      disabled: true
    },
    attrs: {
      "disabled": _vm.disabled,
      "type": "text",
      "min": _vm.min,
      "step": _vm.step,
      "max": _vm.max
    },
    domProps: {
      "value": _vm.displayValue
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      },
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "blur": function($event) {
        return _vm.handleBlur($event.target.value)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.arrowUp.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.arrowDown.apply(null, arguments)
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spinner-button spinner-up",
    class: {
      'spinner-button-disabled': _vm.disabled
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.arrowUp
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-up spinner-icon-up"
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-button spinner-down",
    class: {
      'spinner-button-disabled': _vm.disabled
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.arrowDown
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-down spinner-icon-down"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42db20d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42db20d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderComponent/RxInput.vue
// module id = 510
// module chunks = 4